export var AUTO_MESSAGES = {
    BADGE_ID: 'Automated Message',
};
//# sourceMappingURL=messages.js.map